import { render, staticRenderFns } from "./InboxChat.vue?vue&type=template&id=116dfe42"
import script from "./InboxChat.vue?vue&type=script&lang=js"
export * from "./InboxChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports